import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {environment} from 'environment';
import {AuthRequest} from 'shared/auth-request/auth-request';

import {Answer, Dialog, DialogStats, ThesesStats} from '../model/model';

const HTTP_OK_CODE: number = 200;

@Injectable()
export class DialogsRepository {

  constructor(
    private _http: HttpClient,
    private _authRequest: AuthRequest,
  ) { }

  public getDialogs(devOptions?: string): Observable<Array<Dialog>> {
    return this._authRequest.handleRequest(
      this._http.get(environment.dialogs.dialogsRoute + (devOptions !== undefined ? devOptions : ''), {withCredentials: true}))
      .pipe(map((response) => <Array<Dialog>> response));
  }

  public postDialogAnswers(answers: Array<Answer>): Observable<boolean> {
    return this._authRequest.handleRequest(
      this._http.post(environment.dialogs.answerRoute, answers, {observe: 'response', responseType: 'text', withCredentials: true})
      .pipe(map((response) => response.status === HTTP_OK_CODE)));
  }

  // the initial bunch of theses for onboarding
  public getTheses(): Observable<Array<Dialog>> {
    return this._authRequest.handleRequest(
      this._http.get(environment.theses.thesesRoute, {withCredentials: true}))
      .pipe(map((response) => <Array<Dialog>> response));
  }

  public postThesisgAnswer(thesisId: string, text: Dictionary<string>, value: number): Observable<boolean> {
    return this._authRequest.handleRequest(
      this._http.post(environment.theses.thesesRoute, {thesis: thesisId, text: text, answer: value}, {observe: 'response', responseType: 'text', withCredentials: true})
      .pipe(map((response) => response.status === HTTP_OK_CODE)));
    }

  public getThesesStats(name: string, date: Date | string, range: string, group: string): Observable<Array<ThesesStats>> {
    let query = '';
    if ( name !== undefined && name != null ) {
      query += (query == '' ? '?' : '&') + 'name=' + name;
    }
    if ( date !== undefined && name != null ) {
      query += (query == '' ? '?' : '&') + 'date=' + (date instanceof Date ? date.toISOString() : date);
    }
    if ( range !== undefined && range != null ) {
      query += (query == '' ? '?' : '&') + 'range=' + range;
    }
    if ( group !== undefined && group != null ) {
      query += (query == '' ? '?' : '&') + 'group=' + group;
    }
    return this._authRequest.handleRequest(
      this._http.get(environment.theses.statsRoute+query, {withCredentials: true}))
      .pipe(map((response) => <Array<ThesesStats>> response));
  }

  public getDialogsStats(): Observable<DialogStats> {
    return this._authRequest.handleRequest(
      this._http.get(environment.dialogs.dialogsStatsRoute, {withCredentials: true}))
      .pipe(map((response) => <DialogStats> response));
  }
}
